/* eslint-disable import/extensions */
import { HomePage } from 'pages/HomePage';
import { SignInPage } from 'pages/SignInPage';
import { AuthCodePage } from 'pages/AuthCodePage';
import { useRoutes } from 'react-router';
import { AuthPage } from 'pages/AuthPage';
import { NotFoundPage } from 'pages/404';

import { InactivityPage } from 'pages/InactivityPage';
import { ShopsPage } from 'pages/ShopsPage';
import { GoodsPage } from 'pages/GoodsPage';
import { ClassificationsPage } from 'pages/ClassificationsPage';
import { PATHS } from './constants';

export const NavigateList = () => {
	const routes = useRoutes([
		{
			path: PATHS.AUTH_CODE_PAGE,
			element: <AuthCodePage />,
		},
		{
			path: PATHS.AUTH_PAGE,
			element: <AuthPage />,
		},
		{
			path: PATHS.HOME_PAGE,
			element: <HomePage />,
		},
		{
			path: PATHS.SIGN_IN_PAGE,
			element: <SignInPage />,
		},
		{
			path: PATHS.INACTIVITY_PAGE,
			element: <InactivityPage />,
		},
		{
			path: PATHS.SHOPS_PAGE,
			element: <ShopsPage />,
		},
		{
			path: PATHS.GOODS_PAGE,
			element: <GoodsPage />,
		},
		{
			path: PATHS.CLASSIFICATIONS_PAGE,
			element: <ClassificationsPage />,
		},
		{
			path: '*',
			element: <NotFoundPage />,
		},
	]);
	return routes;
};
